import React from 'react'

const TableHeaderCell = ({ text }) => {
  return (
    <th scope='col' className='py-3 px-6'>
      {text}
    </th>
  )
}

export default TableHeaderCell
